export const fundTransferConstants = {
  FUND_TRANSFER_PAY_FROM_LIST_REQUEST: "FUND_TRANSFER_PAY_FROM_LIST_REQUEST",
  FUND_TRANSFER_PAY_FROM_LIST_COMPLETE: "FUND_TRANSFER_PAY_FROM_LIST_COMPLETE",
  FUND_TRANSFER_PAY_FROM_LIST_ERROR: "FUND_TRANSFER_PAY_FROM_LIST_ERROR",

  FUND_TRANSFER_PAY_TO_LIST_REQUEST: "FUND_TRANSFER_PAY_TO_LIST_REQUEST",
  FUND_TRANSFER_PAY_TO_LIST_COMPLETE: "FUND_TRANSFER_PAY_TO_LIST_COMPLETE",
  FUND_TRANSFER_PAY_TO_LIST_ERROR: "FUND_TRANSFER_PAY_TO_LIST_COMPLETE",

  FUND_TRANSFER_OWN_INITIALIZE_REQUEST: "FUND_TRANSFER_OWN_INITIALIZE_REQUEST",
  FUND_TRANSFER_OWN_INITIALIZE_COMPLETE:
    "FUND_TRANSFER_OWN_INITIALIZE_COMPLETE",
  FUND_TRANSFER_OWN_INITIALIZE_ERROR: "FUND_TRANSFER_OWN_INITIALIZE_ERROR",

  CLEAR_FUND_TRANSFER_FORMS: "CLEAR_FUND_TRANSFER_FORMS",
  CLEAR_FUND_TRANSFER_INTIALIZATION: "CLEAR_FUND_TRANSFER_INTIALIZATION",
  FAVOURITE_CLEAR_FUND_TRANSFER_INTIALIZATION:
    "FAVOURITE_CLEAR_FUND_TRANSFER_INTIALIZATION",

  FUND_TRANSFER_CURRENCY_CONVERTION_REQUEST:
    "FUND_TRANSFER_CURRENCY_CONVERTION_REQUEST",
  FUND_TRANSFER_CURRENCY_CONVERTION_COMPLETE:
    "FUND_TRANSFER_CURRENCY_CONVERTION_COMPLETE",
  FUND_TRANSFER_CURRENCY_CONVERTION_ERROR:
    "FUND_TRANSFER_CURRENCY_CONVERTION_ERROR",

  FUND_TRANSFER_TYPE_OWN_ACCOUNT: "OWN_ACCOUNT",
  FUND_TRANSFER_TYPE_OTHER_LOLC_ACCOUNT: "OTHER_ACCOUNT",
  FUND_TRANSFER_TYPE_THIRD_PARTY_ACCOUNT: "THIRD_PARTY_ACCOUNT",

  FUND_TRANSFER_FLOW_INITIATE_STATUS: "INITIATE",

  FUND_TRANSFER_OTP_REQUEST: "FUND_TRANSFER_OTP_REQUEST",
  FUND_TRANSFER_OTP_COMPLETE: "FUND_TRANSFER_OTP_COMPLETE",
  FUND_TRANSFER_OTP_ERROR: "FUND_TRANSFER_OTP_ERROR",

  FUND_TRANSFER_PROCEED_REQUEST: "FUND_TRANSFER_PROCEED_REQUEST",
  FUND_TRANSFER_PROCEED_COMPLETE: "FUND_TRANSFER_PROCEED_COMPLETE",
  FUND_TRANSFER_PROCEED_ERROR: "FUND_TRANSFER_PROCEED_ERROR",

  FUND_TRANSFER_SUCCESS_STATUS: "SUCCESS",
  FUND_TRANSFER_INITIATE_STATUS: "INITIATE",
  FUND_TRANSFER_FAILED_STATUS: "FAILED",
  FUND_TRANSFER_FAIL_STATUS: "FAIL",
  FUND_TRANSFER_PENDING_STATUS: "PENDING",

  FUND_TRANSFER_RECURRING_ONTIME: "ONETIME",

  SET_FUND_TRANSFER_OWN_FORM_DATA: "SET_FUND_TRANSFER_OWN_FORM_DATA",

  FUND_TRANSFER_BANK_LIST_REQUEST: "FUND_TRANSFER_BANK_LIST_REQUEST",
  FUND_TRANSFER_BANK_LIST_COMPLETE: "FUND_TRANSFER_BANK_LIST_COMPLETE",
  FUND_TRANSFER_BANK_LIST_ERROR: "FUND_TRANSFER_BANK_LIST_ERROR",

  FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_REQUEST:
    "FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_REQUEST",
  FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_COMPLETE:
    "FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_COMPLETE",
  FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_ERROR:
    "FUND_TRANSFER_VALIDATE_ACCOUNT_DETAIL_ERROR",

  SCHEDULED_FUND_TRANSFER_SUCCESS_STATUS: "success",
  SCHEDULED_FUND_TRANSFER_PENDING_STATUS: "pending",
  SCHEDULED_FUND_TRANSFER_FAILED_STATUS: "failed",
};
